
    import { defineComponent } from 'vue';
    import WebSalesSettingsService from '@/apps/shared/services/webSalesSettings-service';
    
    type ContactFormData = {
        whatsappNumber?: string;
        hoursOfAttention?: string;
    };

    export default defineComponent({
        name: 'WhatsApp',
        data() {
            return {
                formData: {
                    whatsappNumber: '+54 9 3493 510404',
                    hoursOfAttention: 'Lunes a Viernes de 8 a 20 hs.'
                }
            };
        },

        computed: {
            whatsappLink(): string {
                const cleanNumber = this.formData.whatsappNumber.replace(/\D/g, '');
                return `https://wa.me/${cleanNumber}?from=numutiles`;
            }
        },

        async mounted() {
            await this.loadWhatsappSettings();
        },

        methods: {
            async loadWhatsappSettings(): Promise<void> {
                try {
                    const settings = await WebSalesSettingsService.getWhatsappSettings();
                    
                    if (settings.whatsapp) {
                        this.formData.whatsappNumber = settings.whatsapp;
                    }

                    if (settings.businessHoursText) {
                        this.formData.hoursOfAttention = settings.businessHoursText;
                    }
                } catch (error) {
                    console.error('Error al obtener los datos de WhatsApp:', error);
                }
            }
        },
    });
